'use client';
import { createPortal } from 'react-dom';

// Generic slide-up bottom sheet — dark backdrop, rounded top corners, drag
// handle, safe-area padding. Used for any mobile-only "sheet" surface
// (dialogs, info popovers, etc.) so the animation/backdrop/structure lives
// in exactly one place instead of being re-implemented per component.
export const BottomSheet = ({ visible, onHide, title, children, zIndex = 2000 }) => {
    if (!visible) return null;

    return createPortal(
        <>
            <style>{`
                @keyframes ennix-bottom-sheet-up {
                    from { transform: translateY(100%); }
                    to   { transform: translateY(0); }
                }
            `}</style>
            <div
                onClick={onHide}
                style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex }}
            />
            <div
                style={{
                    position: 'fixed', bottom: 0, left: 0, right: 0,
                    background: '#fff', borderRadius: '18px 18px 0 0',
                    zIndex: zIndex + 1,
                    animation: 'ennix-bottom-sheet-up 0.28s cubic-bezier(0.32,0.72,0,1)',
                    paddingBottom: 'env(safe-area-inset-bottom, 0px)',
                    maxHeight: '90vh', overflowY: 'auto',
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 10, paddingBottom: 2 }}>
                    <div style={{ width: 36, height: 4, borderRadius: 99, background: '#e2e8f0' }} />
                </div>
                {title && (
                    <div className="flex align-items-center justify-content-between" style={{ padding: '0.25rem 1.25rem 0.5rem' }}>
                        <p className="m-0 font-bold text-900" style={{ fontSize: '0.95rem' }}>{title}</p>
                        <i
                            className="pi pi-times text-500"
                            style={{ fontSize: '0.85rem', cursor: 'pointer', padding: '0.25rem' }}
                            onClick={onHide}
                        />
                    </div>
                )}
                <div style={{ padding: '0.5rem 1.25rem 1.5rem' }}>
                    {children}
                </div>
            </div>
        </>,
        document.body
    );
};
